//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { db } from "/src/main.js";

export default {
  data() {
    return {
      isEditing: false,
    };
  },
  watch: {
    startTime(newVal) {
      if (this.annotation.startTime) {
        this.annotation.startTime = parseFloat(newVal);
      }
    },
  },
  computed: {
    startTime() {
      var raw = String(this.annotation.startTime);
      if (raw.includes(":") && this.isEditing === false) {
        var colon = raw.indexOf(":");
        return (
          parseInt(raw.substring(0, colon)) * 60 +
          parseInt(raw.substring(colon + 1))
        );
      }
      return parseFloat(raw);
    },
  },
  methods: {
    deleteAnnotation(classKey, lessonKey, annotationKey) {
      this.isEditing = false;
      db.ref(`annotations/${classKey}/${lessonKey}/${annotationKey}`).remove();
    },
    updateAnnotation(classKey, lessonKey, annotationKey, data) {
      this.isEditing = false;
      this.annotation.startTime = parseFloat(this.startTime);
      db.ref(`annotations/${classKey}/${lessonKey}/${annotationKey}`).set(data);
    },
  },
  props: {
    classKey: {
      default: null,
    },
    lessonKey: {
      default: null,
    },
    annotationKey: {
      default: null,
    },
    annotation: {
      default: null,
    },
  },
};
